define( function() {
	return ( /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/ ).source;
} );



// WEBPACK FOOTER //
// ./~/jquery/src/var/pnum.js